export default __webpack_public_path__ + "assets/images/36c52c411163ed3b5dbc6e32bea3796a.jpg";